<template>
  <div class="aliProductLayout">
    <div class="topNav">
      <ul class="keyWordmenu clearfix" v-cloak>
        <li v-for="(el, index) in routes" :key="index" @click="activeIndex = index">
          <router-link :to="{ path: el.url }">{{ el.name }}</router-link>
        </li>
        <li>
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzI0MDY3ODkxNA==&mid=100000828&idx=3&sn=e97916440a4f9005df56dd289df42d9a&scene=19#wechat_redirect"
            target="_blank"
          >
            <i class="iconfont icontishi " style="margin-right: 5px;color:#9c9c9c"></i>
            图文教程
          </a>
        </li>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
const keys = "";
export default {
  data() {
    return {
      activeIndex: 0,
      routes: [
        {
          name: "方正字体检测",
          url: "/illegalFont/fontCheck",
          key: keys,
        },
        {
          name: "检测结果",
          url: "/illegalFont/fontCheckRecord",
          key: keys,
        },
      ],
    };
  },
  methods: {},
  computed: {
    childRoutes() {
      return null;
    },
  },

  mounted() {
    // console.log(this.$route);
    if (this.$route.name == "fontCheckRecord") {
      this.activeIndex = 1;
    }
    if (this.$route.name == "fontCheck") this.activeIndex = 0;
  },
  updated() {
    if (this.$route.name == "fontCheckRecord") {
      this.activeIndex = 1;
    }
    if (this.$route.name == "fontCheck") this.activeIndex = 0;
  },
  methods: {
    changeActiveIndex(index) {
      debugger;
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.aliProductLayout {
  height: 100%;
}
.keyWordmenu {
  border-bottom: 1px solid #f1f1f1;
  background: #fff;
  padding: 0 20px;
}
.keyWordmenu li {
  float: left;
  margin-bottom: -1px;
}
.keyWordmenu li a,
.keyWordmenu li a:visited {
  display: inline-block;
  height: 54px;
  line-height: 54px;
  padding: 0 20px;
  font-size: 14px;
  border-bottom: 2px solid transparent;
}
.keyWordmenu li a:hover {
  color: #1c64f4;
}
.keyWordmenu li a.router-link-active {
  border-bottom: 2px solid #1c64f4;
  color: #1c64f4;
}
a {
  color: #333;
}
</style>
